import React from "react";
import { StaticQuery, graphql, Link } from "gatsby";

export default () => (
  <StaticQuery
    query={graphql`
      {
        sheltonJobs: allLever(
          limit: 100
          filter: { categories: { location: { eq: "Shelton, Connecticut" } } }
        ) {
          edges {
            node {
              text
              id
              lever_id
              description
              additional
              categories {
                commitment
                department
                location
                team
              }
              lists {
                text
                content
              }
              hostedUrl
              applyUrl
            }
          }
        }
      }
    `}
    render={data => {
      const sheltonJobs = data.sheltonJobs.edges.map(sheltonJob => {
        return {
          jobTitle: sheltonJob.node.text,
          id: sheltonJob.node.id,
          leverId: sheltonJob.node.lever_id,
          description: sheltonJob.node.description,
          location: sheltonJob.node.categories.location
        };
      });

      const locations = Array.from(
        new Set(sheltonJobs.map(item => item.location))
      ).sort();

      return (
        <>
          {/* Begins looping through array of locations */}
          {locations.map(location => (
            // If you're going to output a list of things, you need a key
            <React.Fragment key={location}>
              <ul className="openings">
                {/* We're starting with a list of all the postings, not just the ones for this particular location, so we need to filter them */}
                {sheltonJobs
                  // Look in each posting
                  // Return only those where that posting's location matches the current location
                  // posting is the argument; posting.location === location is the return value, which is a boolean
                  .filter(sheltonJob => sheltonJob.location === location)
                  // Now our list is just from that one location, so we can use map to output our postings
                  // posting is the argument; the stuff b/w the parentheses produces a JSX element
                  // Again, needs a key because it's a list
                  .map(sheltonJob => (
                    <Link to={`/openings/posting/${sheltonJob.leverId}`}>
                      <li key={sheltonJob.leverId}>{sheltonJob.jobTitle}</li>
                    </Link>
                  ))}
              </ul>
            </React.Fragment>
          ))}
        </>
      );
    }}
  />
);
